import { render, staticRenderFns } from "./SkinWorkshopGallery.vue?vue&type=template&id=7ce58c51&scoped=true&"
import script from "./SkinWorkshopGallery.vue?vue&type=script&lang=ts&"
export * from "./SkinWorkshopGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce58c51",
  null
  
)

export default component.exports